<template>
  <v-card>
    <v-skeleton-loader v-if="loading" type="article"></v-skeleton-loader>
    <div v-else>
      <v-card-title>
        Orden # {{ pedido._id.slice(-5) }}
        <v-spacer></v-spacer>
        <v-btn
          class="ma-2"
          color="green"
          fab
          small
          dark
          v-if="pedido.estado.val == 'pendiente_pago'"
          @click="generarVenta()"
        >
          <v-icon>mdi-cash-plus</v-icon>
        </v-btn>
        <v-btn class="ma-2" color="red" fab small dark @click="_cerrar()">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-subtitle
        ><v-icon>mdi-{{ pedido.estado.icono }}</v-icon
        >{{ pedido.estado.texto }}</v-card-subtitle
      >
      <v-card-text>
        <v-alert type="success" v-if="pedido.estado.val != 'pendiente_pago'">
          Pagado el dia
          <b
            >{{
              $moment(pedido.fechaVenta).format("dddd DD [de] MMMM YYYY H:mm")
            }}
            hs</b
          >.
          <v-btn text @click="verComprobante()"><v-icon class="mr-2">mdi-eye</v-icon> Ver comprobante</v-btn>
        </v-alert>
        <v-alert type="info" v-if="!pedido.fechaEntrega"
          >
          <span v-if="pedido.envio.tipo == 'sucursal'">Retira por sucursal</span>
          <v-btn v-if="pedido.fechaVenta" text @click="pedidoRetirado()" :loading="loadingPedidoRetirado"><v-icon class="mr-2">mdi-check</v-icon> YA LO RETIRARON</v-btn></v-alert
        >
        <v-alert type="success" v-else>Entregado el dia <b>{{$moment(pedido.fechaEtnrega).format('dddd DD [de] MMMM YYYY H:mm')}} hs</b>.</v-alert>
        <v-alert type="info" outlined v-if="pedido.mensaje" dense>
          Observaciones: {{pedido.mensaje}}
        </v-alert>
        <v-simple-table dense>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">Cliente</th>
                <th class="text-left">Tipo de Responsable</th>
                <th class="text-left">Documento</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{{ pedido.cliente.nombre }}</td>
                <td>{{ pedido.cliente.tipo_responsable }}</td>
                <td>
                  {{ pedido.cliente.documento.tipo }}
                  {{ pedido.cliente.documento.numero }}
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
        <v-simple-table dense>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">Contacto</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in pedido.cliente.contactos" :key="item._id">
                <td>
                  <v-icon
                    >mdi-{{ item.medio == "sms" ? "phone" : "at" }}</v-icon
                  >
                  {{ item.dato }}
                  <v-icon v-if="item.verificado">mdi-check</v-icon>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
        <v-simple-table dense>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">Direccion</th>
                <th class="text-left">Ciudad</th>
                <th class="text-left">Provincia</th>
                <th class="text-left">CP</th>
                <th class="text-left">Referencia</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in pedido.cliente.direcciones" :key="item._id">
                <td>({{ item.descripcion }}) {{ item.direccion_1 }}</td>
                <td>{{ item.ciudad.nombre }}</td>
                <td>{{ item.provincia.nombre }}</td>
                <td>{{ item.cp }}</td>
                <td>{{ item.direccion_2 }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
        <v-simple-table dense>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">Producto</th>
                <th class="text-left">Cantidad</th>
                <th class="text-left">Stock</th>
                <th class="text-left">Precio Unitario</th>
                <th class="text-left">Total</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in pedido.productos" :key="index">
                <td>{{ item.nombre }}</td>
                <td>
                  {{ item.cantidad }}
                </td>
                <td>
                  {{ item.stock }}
                  <v-icon
                    >mdi-{{
                      item.stock >= item.cantidad ? "check" : "cancel"
                    }}</v-icon
                  >
                </td>
                <td>
                  {{ item.precio }}
                </td>
                <td>{{ item.total }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
        <v-simple-table dense>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">Subtotal</th>
                <th class="text-left">Costo de Envio</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>$ {{ pedido.subtotal }}</td>
                <td>$ {{ pedido.costoEnvio }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
        <v-simple-table dense>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left"><b>Total</b></th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <b>$ {{ pedido.total }}</b>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
        <p class="text-right font-italic">Orden generada en la web el dia {{
            $moment(pedido.fechaAlta).format("dddd DD [de] MMMM YYYY H:mm")
          }}
          hs</p>
      </v-card-text>
    </div>
  </v-card>
</template>

<script>
import axios from "axios";
export default {
  name: "Pedidos_Ver",
  data: () => ({
    loading: true,
    pedido: null,
    loadingPedidoRetirado: false
  }),
  computed: {
    _id() {
      return this.$route.params._id;
    },
  },
  methods: {
    async _obtenerPedido() {
      this.loading = true;
      try {
        const pedido = await axios.get("/pedido/" + this._id);
        this.pedido = pedido.data;
        this.loading = false;
      } catch (error) {
        this.$router.push("/pedidos");
      }
    },
    _cerrar() {
      this.$router.go(-1);
    },
    generarVenta() {
      this.$router.push({
        name: "Ventas_Nuevo",
        params: {
          presupuesto: {
            cliente: this.pedido.cliente,
            productos: this.pedido.productos.map((producto) => ({
              producto: {
                _id: producto._id,
              },
              cantidad: producto.cantidad,
            })),
          },
          pedido: this.pedido,
        },
      });
    },
    verComprobante() {
      if(this.pedido.venta) this.$router.push("/ventas/" + this.pedido.venta)
    },
    async pedidoRetirado() {
      this.loadingPedidoRetirado = true
      try {
        if(!await axios.post("/pedido/retirado", { pedido: this._id })) throw Error('pedido incorrecto')
        this._obtenerPedido();
      } catch (error) {
        console.log(error)
      }
      this.loadingPedidoRetirado = false
    }
  },
  created() {
    this._obtenerPedido();
  },
};
</script>
